import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import styles from './RichTextContentEditor.module.css'

const isQuillEmpty = (html) => {
  if (!html || typeof html !== 'string') {
    return true
  }
  return html.replace(/<[^>]+>/g, '').trim() === ''
}

const RichTextContentEditor = ({ onChange, value }) => {
  const quillRef = useRef()
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          ['bold', 'italic', 'underline'],
          ['link'],
          [{ align: ['', 'center', 'right', 'justify'] }],
          [{ list: 'ordered' }, { list: 'bullet' }]
        ]
      },
      clipboard: {
        matchVisual: false
      }
    }),
    []
  )

  const formats = [
    'bold',
    'italic',
    'underline',
    'align',
    'list',
    'link',
    'bullet',
    'indent',
    'color',
    'clean'
  ]

  return (
    <div className={styles.wrapper}>
      <ReactQuill
        ref={quillRef}
        className={styles.editor}
        formats={formats}
        modules={modules}
        onChange={(content, _delta, source) => {
          if (source !== 'user') {
            // Quill emits empty api updates when editors unmount (e.g. Collapse panels).
            if (isQuillEmpty(content) && value && !isQuillEmpty(value)) {
              return
            }
            return
          }
          onChange(content)
        }}
        theme='snow'
        value={value}
      />
    </div>
  )
}

RichTextContentEditor.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}

export default RichTextContentEditor
